import navScroll from './navScroll';
import modalWindow from './modalWindow';

/*
    Скролл до элемента по клику по
    ссылкам в хедере и футере
*/
navScroll();

/* 
    модалка для скачивание программы тис
*/
modalWindow();

/*mobile left menu*/
document.addEventListener('DOMContentLoaded', function() {
    let burgerElement = document.querySelector('.btn-menu');
    let leftMenuElement = document.querySelector('.nav-list-m-wrapper');

    burgerElement.addEventListener('click', function(e) {
        leftMenuElement.classList.add('show');
        closeWhenBodyClicked();
    });

    let hideShowingElements = function(e) {
        // console.log(e.target);
        if(e.target !== burgerElement) {
            let shownElements = document.querySelectorAll('.show'), needToRemoveListener = true;
            // console.log(shownElements);
            shownElements.forEach(item => {
                // console.log(item.querySelector(`.${e.target.classList[0]}`));
                
                if(e.target === item || item.querySelector(`.${e.target.classList[0]}`) !== null) {
                    needToRemoveListener = false;
                    return false;
                }
                item.classList.remove('show');
            });
            if(needToRemoveListener) {
                
                document.body.removeEventListener('click', hideShowingElements, true);
            }
        }
    };

    function closeWhenBodyClicked() {
        document.body.addEventListener('click', hideShowingElements, true); 
    }
    console.log($(window).width());
    if($(window).width() < 575) {
        console.log($('.about.container').find('.about-item'));
        $('.about.container').find('.about-item').unwrap().wrapAll('<div class="slider-wrapper"><div class="slider"></div><div class="clearfix"></div></div>');
        $('.about.container').find('.about-item').attr('class', 'about-item');
        /*slider on mobile*/
        $('.slider-wrapper').flexslider({
            selector: ".slider > .about-item",
            animation: "fade",
            animationLoop: true,
            touch: true,
            maxItems: 1,
            move: 1,
            directionNav: false,
            controlNav: true
        });
    }
});


